export default __webpack_public_path__ + "static/media/gamepad_blue_gradient.a70e0921.svg";